import { Grid, makeStyles } from "@material-ui/core";
import { ELeftSideMenu } from "api/enums";
import { ContractStore } from "store";
import MenuAddsAndCancels from "./AdditivesAndCancellations/MenuAddsAndCancels";
import MenuLineHistory from "./MenuLineHistory";
import MenuReadjustment from "./MenuReadjustment";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.gray[900],
    overflowY: "auto",
    height: "calc(100vh - 46px)",
  },
}));

const MenuLeftSideBar = () => {
  const classes = useStyles();
  const { openLeftSideMenu } = ContractStore;

  return (
    <Grid
      container
      className={classes.container}
      justifyContent="flex-start"
      alignContent="flex-start"
    >
      {openLeftSideMenu === ELeftSideMenu.ADDS_AND_CANCELS && (
        <MenuAddsAndCancels />
      )}
      {openLeftSideMenu === ELeftSideMenu.LINE_HISTORY && <MenuLineHistory />}
      {openLeftSideMenu === ELeftSideMenu.READJUSTMENT && <MenuReadjustment />}
    </Grid>
  );
};

export default MenuLeftSideBar;
